/*
 * Copyright (C) 2018 Frontier Developments PLC.
 *
 * Titus client exception class.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

// generate prototype of Error
import BaseError from './BaseError';

BaseError.prototype = new Error();

/**
 * API exception type.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export default class ApiException extends BaseError {
    constructor(public status: number, public response: any, public params: any = {}, public additional: any = {}) {
        super();
    }
}
